import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Subway,AirportShuttle,SupervisedUserCircle,Edit,Delete,AccountCircle,AccessTime,RemoveCircleOutline,DepartureBoard,EventBusy,Commute,EditOutlined,RemoveCircleOutlineOutlined,Done} from '@material-ui/icons';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  CircularProgress,
  Grid,
  CardActionArea,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Chip,
  Badge
} from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';


import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import API from './api';

// import * as userInfo from "./login_info.js";
import UserInfo from "./login_info";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Avatar from '@material-ui/core/Avatar';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Skeleton from '@material-ui/lab/Skeleton';


import { useSnackbar } from 'notistack';

import axios from 'axios';

import {TransportService,AdminService, ReportingService} from "./../../utils/web_config_2";

import MaskedInput from "react-text-mask";

import ID from '../../assets/svg/id.svg';

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        flexFlow:1,
        [theme.breakpoints.up('sm')]:{
          marginLeft:250,
        }
      },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},paper: {
  height: 200
},
btn:{
  textTransform:"capitalize"
},
card: {
  width: 280,
  margin:"2px"
},
media: {
  height: 190,
},
schedules: {
  width: '100%',
  maxWidth: 360,
  backgroundColor: theme.palette.background.paper,
}
}));



// mask NID

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/[0-9]/,' ',/[0-9]/ ,/\d/, /\d/, /\d/, ' ', /[0-9]/,' ',/[0-9]/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,' ',/[0-9]/,' ',/[0-9]/,/\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

 function Driver() {
  const classes = useStyles1();
  const Theme = useTheme();
  const [message,setMessage]=useState("");
  
  const matches = useMediaQuery(Theme.breakpoints.up("sm"));

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [driverMessage,setDriverMessage]=useState("");

  // new driver dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setManually(false);
    setDriverStep(0);
  };


  /// driver table 




  const columns = [
    {
      name: "driver_id",
      label: "id",
      options: {
        display:false,
       filter: true,
       sort: true,
      }
     }
    ,
    {
     name: "first_name",
     label: "First name",
     options: {
      filter: true,
      sort: true,
     }
    },{
      name: "last_name",
      label: "Lastname",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "driving_licence_number",
      label: "Driving Lisence",
      options: {
       filter: true,
       sort: false,
      }
     },
     {
     name: "phone_number",
     label: <Translate id="operator_driver.table.phone_number" />,
     options: {
      filter: true,
      sort: false,
     }
    },{
     name: "driver_rura_id",
     label:"RURA ID",
     options: {
      filter: true,
      sort: false,
     }
    },{
      name: "driver_status",
      label:"Status",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <Chip
          color="primary"
          variant="outlined"
          label={value}
          icon={<Done/>}
        ></Chip>
            
        );
      }
      }}
   ];
   
   
   const options = {
    textLabels: {
      body: {
        noMatch: driverMessage
      },
    },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:"single",
     rowsPerPage: 10,
     elevation:0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box>

    <Button color="primary" variant="outlined" style={{marginRight:5}} onClick={()=>{
      var id=displayData[selectedRows.data[0]['index']]['data'][0];

      var d=drivers.find((d)=>d.driver_id==id);

       setDriverid({value:id,error:""});
       setRuraId({value:d['driver_rura_id'],error:""});
       setDl_number({value:d['driving_licence_number'],error:""});
       setFirstName({value:d['first_name'],error:""});
       setLastName({value:d['last_name'],error:""});
       setPhone({value:d['phone_number'],error:""});

       setEditDialog(true);
    }}>
      Edit
    </Button>

    <Button variant="outlined" onClick={()=>{
       var id=displayData[selectedRows.data[0]['index']]['data'][0];
       setDriverid(id);
       setDriverAId(id);
      setRemovedialog(true);
    }}>
      Remove
    </Button>
  
        </Box>
    ),
   };
  


   useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    setOperatorData(data);
    axios.defaults.baseURL = new AdminService().BASE_URL;


    get_drivers(data.token);
   },[]);


   //get drivers
   

   const [loadDrivers,setLoaddrivers]=useState(false);
   const [drivers,setDrivers]=useState([]);
   const get_drivers=(token)=>{
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const driverInstance = axios.create(new AdminService().setHeaders(token));
    setMessage("Loading...");
    setDriverMessage("");
    setLoaddrivers(true);
    driverInstance.get("/api/v1/operator-driver/organization/"+new UserInfo().ORG_ID+"/status/ACTIVE"
     
     ).then(res=>{
      
      setLoaddrivers(false);
         console.log("=== drivers ===");
         console.log(res.data);
         if(res.data.length==0){
          setDriverMessage("No drivers available");
         }
        var data=res.data.data;
        var dd=[]
        data.map((d)=>{
          var st=d.driver_status;
          if(st=="ACTIVE"){
            d.driver.driver_status="ACTIVE";
            dd.push(d.driver);
          }
        });
         setDrivers(dd);
     
     })
     .catch(err=>{
      setLoaddrivers(false);
      if(err.message){
        enqueueSnackbar(err.message ,{ 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

      if(err.response){
        enqueueSnackbar(err.response.data.message ,{ 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

     });
   }

   
   // new driver

   const [driverStep,setDriverStep]=useState(0);

   const [ruraId,setRuraId]=useState({value:"",error:""});
   const [driverStatus,setDriverStatus]=useState({load:false,status:false});
   const [dl_number,setDl_number]=useState({value:"",error:""});
   const [firstName,setFirstName]=useState({value:"",error:""});
   const [lastName,setLastName]=useState({value:"",error:""});
   const [status,seStatus]=useState({value:"",error:""});
   const [phone,setPhone]=useState({value:"",error:""});
   const add_driver=()=>{
     if(ruraId.value===""){
       setRuraId({value:"",error:"Enter RURA Id"});
     }else if(dl_number.value===""){
       setDl_number({value:"",error:"Enter driving license number"});
     }else if(firstName.value===""){
       setFirstName({value:"",error:"Enter firstname"});
     }else if(lastName.value===""){
       setLastName({value:"",error:"Enter lastname"});
     }else if(phone.value===""){
       setPhone({value:"",error:"Enter phone number"});
     }else{
       console.log("RURA id"+ruraId.value);
       console.log("dl_number.value"+dl_number.value);
       console.log("firstName.value"+firstName.value);
       console.log("lastName.value"+lastName.value);
       console.log("phone.value"+phone.value);
      setDriverStatus({load:true,status:false}); 
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const driverInstance = axios.create(new AdminService().setHeaders(operatorData.token));  
      driverInstance.post("/api/v1/driver",
        {
          "driver_rura_id": ruraId.value,
          "driving_licence_number": dl_number.value,
          "first_name": firstName.value,
          "last_name": lastName.value,
          "phone_number": phone.value
        }).then(res=>{
          setDriverStatus({load:true,status:false}); 

            const data=res.data['data'];
            // setDriverId({value:data['driver_id'],error:""});
            setTimeout(function(){ assignDriver(data['driver_id'],data); }, 3000);
            //  setPhoto("");
         
     }).catch(err=>{
    
      setDriverStatus({load:false,status:false});

      if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      }); 
      }
    });
    }
   }

   // assign to an organisation 
   const assignDriver=(driverId,data)=>{
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const assignInstance = axios.create(new AdminService().setHeaders(operatorData.token));  
    assignInstance.post("/api/v1/operator-driver",{
      "driver_id": driverId,
      "organization_id":new UserInfo().ORG_ID
    }).then(res=>{
      var objs=drivers;
      data.driver_status="ACTIVE";
      objs.unshift(data);

        setDriverStatus({load:false,status:true}); 
        setOpen(false);

        setPhoto("");
        setFirstName({value:"",error:""});
         setLastName({value:"",error:""});

        var obj=res.data;
        console.log("Driver info");
        console.log(obj);
        enqueueSnackbar('Driver added successful!', { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });

      // get_drivers(operatorData.token);

      setDriverStep(0);

      console.log(res);
      console.log(res.data);
    }).catch(err=>{
      console.log("error======")
       console.log(err);
    })
   }


  //  get driver infos by NID

  const [photo,setPhoto]=useState("");
  const [NID,setNID]=useState({value:"",error:""});
  const [loadInfo,setLoadInfo]=useState(false);
  const get_infos=()=>{
    if(NID.value==""){
      setNID({value:"",error:"Invalid ID"});
    }else if(NID.length==16){
      setNID({value:"",error:"Invalid ID"});
    }
    else{
      setLoadInfo(true);
      const data={
        "document_number": NID.value
    };
    axios.defaults.baseURL = new ReportingService().BASE_URL;
      const infoInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
      infoInstance.post(new ReportingService().GET_NID_INFO,data)
      .then(res=>{
         setLoadInfo(false);
         var obj=res.data.data;
         if(obj.applicationNumber!=null){
          setFirstName({value:obj.foreName,error:""});
          setLastName({value:obj.surnames,error:""});
          setPhoto(obj.photo);
          setDriverStep(1);
          setNID({value:"",error:""});
         }else{
          setNID({value:"Invalid NID",error:""});
         }
        
      })
      .catch(err=>{
  
  
      }); 
    }

   
  }



// remove driver dialog
const [removeDialog,setRemovedialog]=useState(false);


// remove driver
const [removeLoad,setRemoveLoad]=useState(false);
const[driverAId,setDriverAId]=useState(null);
const remove_driver=()=>{
  setRemoveLoad(true);
  
  console.log("driver id",driverAId);
  console.log("organization id",new UserInfo().ORG_ID);
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const driverInstance = axios.create(new AdminService().setHeaders(operatorData.token));  
  driverInstance.put('/api/v1/operator-driver/remove-driver-from-operator',
  {
    "driver_id": driverAId,
    "organization_id": new UserInfo().ORG_ID
  }
  ).then(res=>{
    setRemoveLoad(false);
    setRemovedialog(false);

    // var u=drivers.find((i)=>i.driver_id==driverAId);
    // u['driver_status']="DISACTIVE";
    // var index=drivers.findIndex((i)=>i.id==driverAId);
    // let newArr = [...u]; 
    // newArr[index] = u;

    var n_obj=drivers.filter((d)=>d.driver_id!=driverAId);



    setDrivers(n_obj);

    enqueueSnackbar('Driver removed from this operator successful!', { 
      variant: 'success',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  get_drivers(operatorData.token);
  }).catch(err=>{
    setRemoveLoad(false);
    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  }); 
    console.log(err);
    // if(err.response.status==500){
    //   enqueueSnackbar("Incorrect data!", { 
    //     variant: 'error',
    //     anchorOrigin: {
    //       vertical: 'bottom',
    //       horizontal: 'right',
    //   },
    // }); 
    // }else if(err.response.status==401){
    //   enqueueSnackbar("First login , your session ended!", { 
    //     variant: 'error',
    //     anchorOrigin: {
    //       vertical: 'bottom',
    //       horizontal: 'right',
    //   },
    // }); 
    // }else if(err.response.status==404){
    //   enqueueSnackbar("Something went wrong!", { 
    //     variant: 'error',
    //     anchorOrigin: {
    //       vertical: 'bottom',
    //       horizontal: 'right',
    //   },
    // }); 
    // }
  });
   
}


// driver schedules dialog 

const [schedulesDialog,setSchedulesDialog]=useState(false);


// driver schedules 
const [schedulesMessage,setSchedulesMessage]=useState("");
const [schedules,setSchedules]=useState([]);
const get_schedules=(id)=>{
  setSchedules([]);
 var d=drivers.find(item => {
    return item.id ==id;
});

if(d['schedules'].length==0){
  setSchedulesMessage("No schedules available");
}else{
  setSchedulesMessage("");
  setSchedules(d['schedules']);
}

}


// edit driver dialog 
const [editDialog,setEditDialog]=useState(false);

// update driver dialog
const [editLoad,setEditLoad]=useState(false);
const [driverId,setDriverid]=useState({value:0,error:""});
const update_driver=()=>{
  if(ruraId.value===""){
    setRuraId({value:"",error:"Enter RURA Id"});
  }else if(dl_number.value===""){
    setDl_number({value:"",error:"Enter driving license number"});
  }else if(firstName.value===""){
    setFirstName({value:"",error:"Enter firstname"});
  }else if(lastName.value===""){
    setLastName({value:"",error:"Enter lastname"});
  }else if(phone.value===""){
    setPhone({value:"",error:"Enter phone number"});
  }else{
    setEditLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const driverInstance = axios.create(new AdminService().setHeaders(operatorData.token));  
    driverInstance.put('/api/v1/driver/'+driverId.value,
    {
      "driver_rura_id": ruraId.value,
      "driving_licence_number":dl_number.value,
      "first_name": firstName.value,
      "last_name": lastName.value,
      "phone_number": phone.value
    })
    .then(res=>{
      var res_obj=res.data.data;
      var index=drivers.findIndex((d)=>d.driver_id==driverId.value);
      var obj=drivers.find((d)=>d.driver_id==driverId.value);
      obj['first_name']=res_obj['first_name'];
      obj['last_name']=res_obj['last_name'];
      obj['driving_licence_number']=res_obj['driving_licence_number'];
      obj['phone_number']=res_obj['phone_number'];
      obj['driver_rura_id']=res_obj['driver_rura_id'];
      var objs=drivers;
      objs[index]=obj;
      setDrivers(objs);

      setEditLoad(false);
      setEditDialog(false);
    enqueueSnackbar("Driver updated successful!", { 
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
    
    })
    .catch(err=>{
      setEditLoad(false);



      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    });
  
  }
}


const [manually,setManually]=useState(false);


  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}> <SupervisedUserCircle fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Drivers</b></Typography>

 </Box>
 
 
<Button  
        className={classes.btn}
        size="small"
        startIcon={<Add/>} 
        onClick={()=>{handleClickOpen()}} 
        variant="contained" 
        color="primary"
        disableElevation={true}>

<Typography noWrap><Translate id="operator_driver.new_driver" /></Typography>
</Button>
 
     </Box>

 {/* vehicles table  */}

 <Box mt={2}>
   {/* {loadDrivers&&<LinearProgress/>} */}
  {driverMessage!=""&&<Box display="flex" justifyContent="center" mt={5}><Box display="flex"><Box display="flex"><Commute fontSize="large"/></Box><Box><Typography variant="h6">{driverMessage}</Typography></Box></Box></Box> }





<Grid container spacing={1}>

{/* {drivers.map((d)=>{
return  <Grid item xs={12} sm={6} md={6} lg={3}>
<Box
  display="flex"
  justifyContent="center"
  alignItems="center"
  flexDirection="column"
  bp={1}
>
  
    <Paper elevation={0}>
       <Box display="flex" ><Box  justifyContent="flex-end" p={1} m={1} bgcolor="background.paper">
         <IconButton onClick={()=>{
           
            setDriverid({value:d['driver']['driver_id'],error:""});
            setRuraId({value:d['driver']['driver_rura_id'],error:""});
            setDl_number({value:d['driver']['driving_licence_number'],error:""});
            setFirstName({value:d['driver']['first_name'],error:""});
            setLastName({value:d['driver']['last_name'],error:""});
            setPhone({value:d['driver']['phone_number'],error:""});

            setEditDialog(true);
         }}>
           <EditOutlined fontSize="small"/>
         </IconButton></Box> </Box>
      <Box
        height="100px"
        width={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <AccountCircle color="secondary" style={{ fontSize: 60 }} />
      </Box>
      <Box ml={1} lmt={1} mb={1} alignSelf="flex-end" alignItems="center">
      <Grid container>
      <Grid xs={12} md={12} sm={12} lg={12}>
<Typography wrap color="inherit">{"NID: "+d['driver']['driving_licence_number']}</Typography>
        </Grid>

        <Grid xs={12} md={6} sm={6} lg={6}>
<Typography color="inherit">{d['driver']['first_name']+" "+d['driver']['last_name']}</Typography>
        </Grid>
        <Grid xs={12} md={6} sm={6} lg={6}>
        <Typography color="inherit">{d['driver']['phone_number']}</Typography>
        </Grid>
        <Grid xs={12} md={12} sm={12} lg={12}>
        <Typography color="inherit">{d['driver']['driver_rura_id']}</Typography>
        </Grid>
      
        <Grid xs={6} md={6} sm={12} lg={6}>
        <Button 
        startIcon={<RemoveCircleOutlineOutlined/>}
        onClick={()=>{
           setDriverid(d['driver']['driver_id']);
           setDriverAId(d['driver']['driver_id']);
          setRemovedialog(true);
        }}  className={classes.btn}  variant="outlined" color="secondary">
       <Typography noWrap> Remove</Typography>
          
        </Button>
        </Grid>

      </Grid>
      </Box>
    </Paper>
  
</Box>
</Grid>;

})} */}

  
              </Grid>        
{loadDrivers&&<LinearProgress color="primary"/>} 
 <MUIDataTable
  // title={"Driver list"}
  data={drivers}
  columns={columns}
  options={options}
/>

 </Box> 

{/* dialog new driver  */}

    <Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle ><Translate id="operator_driver.new_driver" /></DialogTitle>
        <DialogContent>
          <DialogContentText >

            {driverStep==0&&
            <Box>
              <Box display="flex" justifyContent="center">
                <img src={ID} width="100" height="100"/>
              </Box>
              <Box display="flex" justifyContent="center">
                <Typography color="secondary">Please enter NID</Typography>
              </Box>
            <Box mt={1} display="flex" justifyContent="center">
            <TextField 
            autoFocus
            size='small' 
            variant='outlined' 
            error={NID.error!==""}
            helperText={NID.error}
            value={NID.value}
            onChange={(e)=>{
              var data=e.target.value;
              setNID({value:data,error:""});

            }}

          // InputProps={{
          //   inputComponent: TextMaskCustom,
          //   onChange: (e)=>{
            // var data=e.target.value.replace(" ","");
          //     // setScheduleTime({value:e.target.value,error:""});
          //   },
          // }}

          label={"National ID"}
            color='primary'  fullWidth/>
            </Box>

            <Box mt={1} display="flex" justifyContent="left">
            <Button style={{textTransform:"capitalize"}}  color="primary" onClick={()=>{
                setManually(true);
                setDriverStep(1);
                }}>
                  Continue Manually?
                  </Button>
            </Box>

            </Box>
         }
          

          {driverStep==1&&   <Box>
            
            {manually==false&&
            <Box>
            <Grid container>
              <Grid item  xs={6} md={12} lg={12} sm={12}>
                <Box display="flex" justifyContent="center">
                <StyledBadge
      overlap="circle"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      variant="dot"
    >
     <Avatar src={"data:image/png;base64,"+photo} style={{width:"100px",height:"100px"}}/>
    </StyledBadge>
              
                </Box>
              </Grid>
              <Grid item xs={12} md={12} lg={12} sm={12}>
                <Box display="flex" justifyContent="center">
                <Typography size="small">{firstName.value}</Typography>
                <Typography size="small">{lastName.value}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
            }
            
          <Box display='flex' mt={1} alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' 
          error={firstName.error!==""}
          helperText={firstName.error}
          value={firstName.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setFirstName({value:"",error:"Enter firstname"});
            }else{
              setFirstName({value:e.target.value,error:""});
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.name"/>}  color='primary'  fullWidth/></Box>
          
          
          <Box mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' 
          error={lastName.error!==""}
          helperText={lastName.error}
          value={lastName.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setLastName({value:"",error:"Enter lastname"});
            }else{
              setLastName({value:e.target.value,error:""});
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.lname"/>}  color='primary'  fullWidth/></Box>
         
         
         
          <Box  mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' 
          error={phone.error!=""}
          helperText={phone.error}
          onChange={(e)=>{
            if(e.target.value===""){
              setPhone({value:"",error:"Enter phone number"});
            }else{
              setPhone({value:e.target.value,error:""});
            }
          }} 
          label={<Translate id="operator_driver.form_new_driver.phone_number"/>}  color='primary'  fullWidth/></Box>
          
          


          <Box  mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined'  
          type="number"
          error={ruraId.error!=""}
          helperText={ruraId.error}
          onChange={(e)=>{
            if(e.target.value===""){
              setRuraId({value:"",error:"Enter RUR Id"})
            }else{
              setRuraId({value:e.target.value,error:""});
             
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.rura_id"/>}   color='primary'  fullWidth/></Box> 
         

          <Box  mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' type="number" 
          error={dl_number.error!=""}
          helperText={dl_number.error}
          onChange={(e)=>{
            if(e.target.value===""){
              setDl_number({value:"",error:"Enter driving license"});
            }else{
              setDl_number({value:e.target.value,error:""});
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.dl_number"/>}   color='primary'  fullWidth/></Box> 
        </Box>
         }
          
          </DialogContentText>
        </DialogContent>
       <DialogActions>
          
          <Button variant="outlined" onClick={handleClose} color="secondary" autoFocus>
          
            <Translate id="operator_driver.form_new_driver.cancel"/>

          </Button>
          {driverStep==1&&
          <Button disableElevation onClick={()=>{add_driver()}} variant="contained" color="primary">
          {driverStatus.load?<CircularProgress size={25} color="secondaryColor"/>:<Translate id="operator_driver.form_new_driver.save"/>}
          </Button>
 }

{driverStep==0&& <Button disableElevation variant="contained" color="primary" onClick={()=>{
                get_infos();
              }}>
               {loadInfo?<CircularProgress  color="secondary" size={25}/>:"Continue"}
                </Button>}
         

        </DialogActions>
        
      </Dialog>




{/* dialog remove driver from operator  */}

<Dialog
    maxWidth="sm"
    fullWidth
        open={removeDialog}
        onClose={()=>{
          setRemovedialog(false);
        }}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle >Remove Driver</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Typography variant="h6">Are you sure , you want to remove this driver from your organization?</Typography>
          </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={()=>{
            setRemovedialog(false);
          }} variant="outlined" color="secondary" >
            No
          </Button>
          <Button disableElevation onClick={()=>{remove_driver(); }} variant="contained" color="primary">
          {removeLoad?<CircularProgress size={25} color="secondaryColor"/>:"Yes"}
          </Button>
        </DialogActions>
    </Dialog>




{/* driver schedules  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={schedulesDialog}
        onClose={()=>{
          setSchedulesDialog(false);
        }}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle >Driver schedules</DialogTitle>
        <DialogContent>
          <DialogContentText >

            {/* <Box width="100%">
              <Box display="flex" width="100%" mt={1}>
                <Grid container width="100%">
                  <Grid md={2} lg={2} xs={2} sm={2}>
                  <Skeleton animation="wave" variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container width="100%">
                      <Grid md={12} lg={12} xs={12} sm={12}>
                      <Skeleton animation="wave" height={10} width="100%" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                      <Skeleton animation="wave" height={10} width="100%" />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Box display="flex" width="100%" mt={1}>
                <Grid container width="100%">
                  <Grid md={2} lg={2} xs={2} sm={2}>
                  <Skeleton animation="wave" variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container width="100%">
                      <Grid md={12} lg={12} xs={12} sm={12}>
                      <Skeleton animation="wave" height={10} width="100%" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                      <Skeleton animation="wave" height={10} width="100%" />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Box display="flex" width="100%" mt={1}>
                <Grid container width="100%">
                  <Grid md={2} lg={2} xs={2} sm={2}>
                  <Skeleton animation="wave" variant="circle" width={40} height={40} />
                  </Grid>
                  <Grid md={10} lg={10} xs={10} sm={10}>
                    <Grid container width="100%">
                      <Grid md={12} lg={12} xs={12} sm={12}>
                      <Skeleton animation="wave" height={10} width="100%" />
                      </Grid>
                      <Grid md={12} lg={12} xs={12} sm={12}>
                      <Skeleton animation="wave" height={10} width="100%" />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              
            </Box>
             */}

             <Box>
              {schedulesMessage!=""&&  <Grid container>
                 <Grid md={1} xs={1} lg={1} sm={1}>
                   <Box alignContent="center">
                   <EventBusy fontSize="large"/>
                   </Box>
                 </Grid>
                 <Grid md={11} xs={11} lg={11} sm={11}>
                 <Box alignContent="center" >
                  <Typography>{schedulesMessage}</Typography>
                  </Box>
                 </Grid>
               </Grid>} 
             
             <List className={classes.schedules}>
               {schedules.map((s)=>{
                 return <ListItem>
                 <ListItemAvatar>
                     <DepartureBoard />
                 </ListItemAvatar>
                 <ListItemText primary={s['route']['name']} secondary={s['scheduled_on_date_time']} />
               </ListItem>;
               })}
    </List>
             </Box>

          </DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={()=>{
            setSchedulesDialog(false);
          }} variant="outlined" color="secondary" >
          close
          </Button>
        </DialogActions>
    </Dialog>



{/* edit driver dialog  */}


<Dialog
    maxWidth="sm"
    fullWidth
        open={editDialog}
        onClose={()=>{
          setEditDialog(false);
        }}
        aria-labelledby="edit_driver"
        aria-describedby="edit_driver"
      >
        <DialogTitle >Edit Driver</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <Box display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' 
          error={firstName.error!==""}
          helperText={firstName.error}
          value={firstName.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setFirstName({value:"",error:"Enter firstname"});
            }else{
              setFirstName({value:e.target.value,error:""});
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.name"/>}  color='primary'  fullWidth/></Box>
          
          
          <Box mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' 
          error={lastName.error!==""}
          helperText={lastName.error}
          value={lastName.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setLastName({value:"",error:"Enter lastname"});
            }else{
              setLastName({value:e.target.value,error:""});
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.lname"/>}  color='primary'  fullWidth/></Box>
         
         
         
          <Box  mt={1} display='flex' alignItems='center' justifyContent='center'><TextField size='small' variant='outlined' 
          error={phone.error!=""}
          helperText={phone.error}
          value={phone.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setPhone({value:"",error:"Enter phone number"});
            }else{
              setPhone({value:e.target.value,error:""});
            }
          }} 
          label={<Translate id="operator_driver.form_new_driver.phone_number"/>}  color='primary'  fullWidth/></Box>
          
          


          <Box  mt={1} display='flex' alignItems='center' justifyContent='center'>
            <TextField size='small' variant='outlined'  
          type="number"
          error={ruraId.error!=""}
          helperText={ruraId.error}
          value={ruraId.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setRuraId({value:"",error:"Enter RUR Id"})
            }else{
              setRuraId({value:e.target.value,error:""});
             
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.rura_id"/>}   color='primary'  fullWidth/></Box> 
         

          <Box  mt={1} display='flex' alignItems='center' justifyContent='center'>
            <TextField size='small' variant='outlined' type="number" 
          error={dl_number.error!=""}
          helperText={dl_number.error}
          value={dl_number.value}
          onChange={(e)=>{
            if(e.target.value===""){
              setDl_number({value:"",error:"Enter driving license"});
            }else{
              setDl_number({value:e.target.value,error:""});
            }
          }}
          label={<Translate id="operator_driver.form_new_driver.dl_number"/>}   color='primary'  fullWidth/></Box> 
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
             setEditDialog(false);
          }} color="secondary" autoFocus>
          
            <Translate id="operator_driver.form_new_driver.cancel"/>

          </Button>
          <Button disableElevation onClick={()=>{
            update_driver();
            }} variant="contained" color="primary">
          {editLoad?<CircularProgress size={25} color="secondaryColor"/>:<Translate id="operator_driver.form_new_driver.save"/>}
          </Button>
        </DialogActions>
      </Dialog>





    </div>
  );
}
export default withLocalize(Driver);